var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.course)?_c('button',{class:{'edit-mode': _vm.editMode},on:{"click":_vm.toggleEditMode}},[_c('span',{staticClass:"preview"},[_c('IconEye',{attrs:{"width":28,"height":28}})],1),_c('span',{staticClass:"edit"},[_c('IconPen',{attrs:{"width":28,"height":28}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }